// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"251":"6c97254c","257":"b049f5e5"}[chunkId] + ".chunk.js";
};